import UserProfile from './user-profile';
import APIKeys from './api-keys';
import HelpfulLinks from './helpful-links';
import Preferences from './preferences';
import Projects from './projects';

import './styles.scss';

const profile = {
  UserProfile,
  APIKeys,
  HelpfulLinks,
  Projects,
  Preferences
};

export default profile;
